// extracted by mini-css-extract-plugin
export default {"root":"ArticleCard_root__8H0ZQ","title":"ArticleCard_title__Q0X8v h3","postDate":"ArticleCard_postDate__JEWc9","square":"ArticleCard_square__b+WVs"};